module.exports = __webpack_public_path__ + "static/media/ticketSignatureEmpty.8c745a88.svg";